import styled from "@emotion/styled"
import { breakpoints, theme } from "../../../utils/styles"

// Opaque full-bleed backdrop behind the rounded card — see TwoColGrid's
// Backdrop for why this is needed (site footer is a fixed, negative
// z-index element revealed only near the true page bottom; flow-root
// stops the card's vertical margin from collapsing through this wrapper
// and re-exposing the bare page background where the footer would bleed
// through).
export const Backdrop = styled.div`
  position: relative;
  z-index: 1;
  background: ${({ theme }) => theme.black};
  display: flow-root;
`

export const Section = styled.section`
  position: relative;
  isolation: isolate;
  overflow: hidden;
  background: ${({ theme }) => theme.secondary};
  color: ${({ theme }) => theme.white};
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-radius: 32px;
  margin: 48px 32px;
  padding: 64px 32px;

  @media (max-width: ${breakpoints.l}px) {
    margin: 24px 16px;
    border-radius: 20px;
    padding: 48px 20px;
  }
`

export const MilestonesLabel = styled.div`
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${theme.primary}CC;
  margin: 48px 0 32px;
  text-align: center;
`

export const HorizontalTrack = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  overflow-x: auto;
  padding-bottom: 8px;
`

export const TrackLine = styled.div`
  position: absolute;
  top: 46px;
  left: calc(50% / var(--count, 6));
  right: calc(50% / var(--count, 6));
  height: 1px;
  background: rgba(255, 255, 255, 0.25);
`

export const TimelineNode = styled.div`
  flex: 1;
  min-width: 130px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
`

export const NodeDate = styled.div`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 16px;
  white-space: nowrap;
`

export const NodeDot = styled.div`
  width: ${({ last }) => (last ? "16px" : "12px")};
  height: ${({ last }) => (last ? "16px" : "12px")};
  border-radius: 50%;
  background: ${theme.primary};
  margin-bottom: 16px;
  box-shadow: ${({ last }) => (last ? `0 0 0 6px ${theme.primary}33` : "none")};
`

export const NodeLabel = styled.div`
  font-size: 15px;
  font-weight: 700;
  text-align: center;
  color: ${({ last }) => (last ? theme.primary : theme.white)};
  padding: 0 8px;
`

export const StatsEyebrow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${theme.primary};
  margin-top: 56px;
  margin-bottom: 20px;

  &::before {
    content: "";
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${theme.primary};
  }
`

export const StatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;

  @media (max-width: ${breakpoints.l}px) {
    grid-template-columns: 1fr;
  }
`

export const StatCard = styled.div`
  border-top: 3px solid ${theme.primary};
  background: rgba(255, 255, 255, 0.04);
  border-radius: 10px;
  padding: 24px;
  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1), background 0.35s ease;

  &:hover {
    transform: translateY(-4px);
    background: rgba(255, 255, 255, 0.07);
  }
`

export const StatNumber = styled.div`
  font-size: 40px;
  font-weight: 800;
  color: ${theme.primary};
  font-family: Nunito, sans-serif;
`

export const StatLabel = styled.div`
  font-size: 16px;
  color: rgba(255, 255, 255, 0.85);
  margin-top: 4px;
`

export const NextButtonRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 56px;
`

export const NextButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 28px;
  background: ${theme.primary};
  color: ${theme.black};
  font-weight: 700;
  font-size: 15px;
  font-family: Nunito, sans-serif;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  svg {
    width: 16px;
    height: 16px;
    transition: transform 0.25s ease;
  }

  &:hover {
    transform: translateY(3px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.35);
  }

  &:hover svg {
    transform: translateY(2px);
  }
`
